import React from "react";
import Icon from "@ant-design/icons";

const AttachmentSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
        <path d="M23.72,45.61s-.07,0-.11,0c-3.28-.03-6.36-1.33-8.66-3.67-2.3-2.34-3.55-5.44-3.53-8.72l.16-19c0-.83.66-1.46,1.51-1.49.83,0,1.49.68,1.49,1.51l-.16,19c-.02,2.48.92,4.82,2.66,6.59,1.74,1.77,4.06,2.75,6.54,2.78.03,0,.05,0,.08,0,5.09,0,9.24-4.11,9.29-9.21l.18-21.81c.01-1.75-.65-3.4-1.88-4.65-1.23-1.25-2.87-1.95-4.62-1.96-.02,0-.04,0-.06,0-3.59,0-6.53,2.91-6.56,6.5l-.17,19.81c0,.94.35,1.83,1.01,2.5.66.67,1.54,1.05,2.49,1.05,1.95.02,3.54-1.55,3.56-3.5l.14-17.06c0-.82.68-1.49,1.5-1.49h.01c.83,0,1.49.68,1.49,1.51l-.14,17.06c-.03,3.6-2.94,6.51-6.58,6.47-1.74-.01-3.38-.71-4.6-1.95s-1.89-2.89-1.87-4.63l.17-19.81c.04-5.27,4.34-9.5,9.64-9.48,2.55.02,4.94,1.04,6.73,2.86,1.79,1.82,2.76,4.23,2.74,6.78l-.18,21.81c-.06,6.74-5.56,12.18-12.29,12.18Z" />
    </svg>
);

const AttachmentIcon = () => <Icon component={ AttachmentSvg } />;

export default AttachmentIcon;
